import API from './api'

const api = new API(1, 'board')

export default {
	get(date, published) {
		if(published !== true) {
			published = false;
		}

		return api.get(`/${date}?published=${published}`)
	},

	set(id, date, rows, published, tasks) {
		if(published !== true) {
			published = false;
		}

		return api.post({ id, date, rows, published, tasks })
	}
}


// WEBPACK FOOTER //
// ./src/lib/board.js